import Styles from './ChatInput.module.scss'
import { Design, FlipLeft } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { ArrowUndo } from 'blaze-ui/icons/16'
import { Caption } from 'blaze-ui/icons'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Menu } from 'components/Menu/Menu'
import { Item } from '@react-stately/collections'
import { CollectionElement } from '@react-types/shared'
import { RevertMenuProps } from './Types'
import { useApplyDesign } from '../useApplyDesign'
import { useApplyCaption } from '../useApplyCaption'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export const RevertMenu = ({ originalContent, originalCaption, fileId }: RevertMenuProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { applyDesign } = useApplyDesign({ fileId })
  const { applyCaption } = useApplyCaption({ fileId })

  const handleAction = (key: React.Key) => {
    switch (key) {
      case 'design':
        if (originalContent) {
          applyDesign(originalContent)
        }
        break
      case 'caption':
        if (originalCaption) {
          applyCaption(originalCaption)
        }
        break
      case 'all':
        if (originalContent) {
          applyDesign(originalContent)
        }
        if (originalCaption) {
          applyCaption(originalCaption)
        }
        break
      default:
        break
    }
  }

  if (!originalContent && !originalCaption) {
    return null
  }

  return (
    <MenuTrigger>
      <Button
        frontIcon={() => <ArrowUndo color="var(--dark-60)" />}
        onPress={() => {}}
        size="sm"
        variant="tertiary"
        rounded={!isSystemRedesignEnabled}
      >
        <Text variant="secondary" color="var(--dark-60)">
          Revert
        </Text>
      </Button>
      <Menu aria-label="Menu" onAction={handleAction} className={Styles.menu}>
        {
          [
            originalContent && (
              <Item key="design" textValue="Revert Design">
                <Design size={16} color="var(--dark-80)" />
                <Text variant="secondary" color="var(--dark-80)">
                  Revert Design
                </Text>
              </Item>
            ),
            originalCaption && (
              <Item key="caption" textValue="Revert Caption">
                <Caption size={16} color="var(--dark-80)" />
                <Text variant="secondary" color="var(--dark-80)">
                  Revert Caption
                </Text>
              </Item>
            ),
            originalContent && originalCaption && (
              <Item key="all" textValue="Revert All">
                <FlipLeft size={16} color="var(--dark-80)" />
                <Text variant="secondary" color="var(--dark-80)">
                  Revert All
                </Text>
              </Item>
            ),
          ].filter(Boolean) as CollectionElement<HTMLElement>[]
        }
      </Menu>
    </MenuTrigger>
  )
}
